/*
Dilip 01/30/2023 3075154998  added execution history functionality
Dilip 02/02/2023 3031450488 addded download functionality for data manager Execution History
Dilip 02/03/2023 3075154998  table column changes
Ashraf 02/04/2023 3075154998  fixed actions issue
Akhila 02/20/2023 3075154998 EST time format in start time and start date
//suresh peddavoora 02/24/2023 3075154998 New UI changes

Akhila 02/27/2023 3075154998 implemented preview file functionality
Ravi 03/15/2023 3075154998 added download icon for Error Record
Akhila 03/17/2023 3075154998 download toast message and loader in preview file
Rohini 03/20/2023 3075154998 Added classname.
Prakash 29/06/2023 3031450488 add pop up tooltip
Prakash 30/06/2023 3031450488 add pop up tooltip
Akhila 05/31/2023 3031450488 pointer bug fixed
Sohel 06/06/2023 3031450488 Added Sample File Functionality
Sohel 06/06/2023 3031450488 Added Sample File Functionality Based on Status
Sohel 06/07/2023 3031450488 Fixed Disabled Action Issue
Sohel 06/07/2023 3031450488 Added Failed Record Functionality
Akhila 06/07/2023 3031450488 added breadcrum code and description
Sohel 06/12/2023 3031450488 Change Label and added Failed Record condition
Sohel 06/12/2023 3031450488 Changed Failed Record condition
*/
import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Tooltip} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../constants/ReusableConstants';
import {httpPaginationPost} from '../../../util/Rest';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import BreadCrums from '../../../util/BreadCrum';

import {
  postGenerateUrl,
} from '../../../redux/reducers/EDI';
import MouseOverPopover from '../../../components/MousePopOver/Tooltip';
import {resetDownloadMsg} from '../../../redux/reducers/PreviewFileData';

const DmExecutionTable = ({executionRowData, type, dmExecution}) => {
  const tableRef = createRef();
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Actions',
      field: '',
      sorting: false,
      maxWidth: 10,
      render: (rowData) => (
        <div className="d-flex">
          {type === 'Export' && rowData?.documentKey && (
            <div
              style={{
                opacity: rowData?.documentKey ? 1 : 0.5,
                cursor: rowData?.documentKey ? 'pointer' : 'default',
              }}
              onClick={() => {
                dispatch(
                  postGenerateUrl(
                    {
                      dockey: rowData?.documentKey,
                    },
                    type,
                  ),
                );
              }}
            >
              {rowData?.documentKey && (
                <MouseOverPopover data={<GetAppOutlinedIcon />} popOverData={'Download'} />
              )}
            </div>
          )}
          {/* {rowData?.logDocumentKey && (
            <div
              className="ml-3"
              style={{
                opacity: rowData?.logDocumentKey ? 1 : 0.5,
              }}
              onClick={() => {
                rowData?.logDocumentKey &&
                  dispatch(
                    postExecutionGenerateUrl(
                      {
                        dockey: rowData?.logDocumentKey,
                      },
                      type
                    )
                  );
                {
                  type === "Export"
                    ? dispatch(
                        fetchDownloadSuccess({
                          response: "Export Execution Downloaded SuccessFully",
                        })
                      )
                    : dispatch(
                        fetchDownloadSuccess({
                          response: "Import Execution Downloaded SuccessFully",
                        })
                      );
                }
              }}
            >
              {rowData?.logDocumentKey && (
                <MouseOverPopover data={<ArchiveOutlinedIcon />} popOverData={"Download"} />
              )}
            </div>
          )}
          {rowData?.sampleFileDocKey && type === "Import" && (
            <div
              className="ml-3"
              style={{ opacity: rowData?.sampleFileDocKey ? 1 : 0.5 }}
              onClick={() => {
                rowData?.sampleFileDocKey &&
                  dispatch(
                    postExecutionGenerateUrl(
                      {
                        dockey: rowData?.sampleFileDocKey,
                      },
                      type
                    )
                  );
                {
                  type === "Export"
                    ? dispatch(
                        fetchDownloadSuccess({
                          response: "Export Execution Downloaded SuccessFully",
                        })
                      )
                    : dispatch(
                        fetchDownloadSuccess({
                          response: "Import Execution Downloaded SuccessFully",
                        })
                      );
                }
              }}
            >
              {rowData?.sampleFileDocKey && (
                <MouseOverPopover data={<GetAppIcon />} popOverData={"Import File"} />
              )}
            </div>
          )}
          {rowData?.failedFileDocKey && type === "Import" && (
            <div
              className="ml-3"
              style={{ opacity: rowData?.failedFileDocKey ? 1 : 0.5 }}
              onClick={() => {
                rowData?.failedFileDocKey &&
                  dispatch(
                    postExecutionGenerateUrl(
                      {
                        dockey: rowData?.failedFileDocKey,
                      },
                      type
                    )
                  );
                {
                  type === "Export"
                    ? dispatch(
                        fetchDownloadSuccess({
                          response: "Export Execution Downloaded SuccessFully",
                        })
                      )
                    : dispatch(
                        fetchDownloadSuccess({
                          response: "Import Execution Downloaded SuccessFully",
                        })
                      );
                }
              }}
            >
              {rowData?.failedFileDocKey && (
                <MouseOverPopover data={<GetAppIcon />} popOverData={"Failed Records"} />
              )}
            </div>
          )}
          {type === "Import" && rowData?.errorDocumentKey && (
            <div
              className="ml-3"
              style={{
                opacity: rowData?.errorDocumentKey ? 1 : 0.5,
              }}
              onClick={() => {
                rowData?.errorDocumentKey &&
                  dispatch(
                    ImportpostGenerateUrl(
                      {
                        dockey: rowData?.errorDocumentKey,
                      },
                      type
                    )
                  );
              }}
            >
              {rowData?.errorDocumentKey && (
                <MouseOverPopover
                  data={<GetAppOutlinedIcon />}
                  popOverData={"Download Error Record"}
                />
              )}
            </div>
          )} */}
        </div>
      ),
    },
    {
      title: 'Code',
      field: 'dmCode',
      render: (rowData) => <span>{rowData.dmCode ? rowData.dmCode : ''}</span>,
    },
    {
      title: 'Status',
      field: 'status',
      render: (rowData) => (
        <span style={{color: rowData.status === 'COMPLETED' ? '#00af00' : '#FA113D'}}>
          {rowData.status}
        </span>
      ),
    },
    {
      title: 'Start Date & Time',
      field: 'startDttm',
      render: (rowData) => (
        <>
          {rowData?.startDttm &&
            moment(rowData?.startDttm).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A')}
        </>
      ),
    },
    {
      title: 'End Date & Time',
      field: 'endDttm',
      render: (rowData) => (
        <>
          {rowData?.endDttm &&
            moment(rowData?.endDttm).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A')}
        </>
      ),
    },
    {
      title: 'Executed By',
      field: 'executedBy',
    },
    {
      title: 'Error Message',
      field: 'errorMessage',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.errorMessage?.split(',').join(', ')} interactive>
            <p className="popup-text">{rowData?.errorMessage?.split(',').join(', ')}</p>
          </Tooltip>
        );
      },
      // render: (rowData) => <span style={{ whiteSpace: "pre-wrap" }}>{rowData.errorMessage}</span>,
    },
  ];

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [submit, setSubmit] = useState(false);
  const {downloadSuccessMsg} = useSelector(
    ({dataManagerGroup}) => dataManagerGroup,
  );

  useEffect(() => {
    if (downloadSuccessMsg) {
      setTimeout(() => {
        dispatch(resetDownloadMsg());
      }, 1500);
    }
  }, [downloadSuccessMsg]);
  return (
    <>
      <div className="global-field-table custom-table col-12 new-standard-textfields popup-block">
        <BreadCrums
          name={'Code'}
          code={executionRowData?.exportCode}
          description={'Description'}
          descriptionValue={executionRowData?.exportDescription}
        />
        <GuiTable
          title=""
          columns={columns}
          tableRef={tableRef}
          data={(query) =>
            new Promise((resolve) => {
              const url = `ediexecution/findall/ediexecutionhistory`;
              const bodyObj = {
                dmCode: executionRowData?.exportCode ? executionRowData?.exportCode : '',
                limit: rows,
                orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                orderDirection: query?.orderDirection,
                tabType: 'ediExport',
                page: submit ?
                  1 :
                  arrayLast && query?.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              if (!executionRowData) {
                resolve({
                  data: [],
                  page: 0,
                  totalCount: 5,
                });
              } else {
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObjects;
                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(response.data.response.resultObjects.length === 1);
                      setSubmit(false);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              }
            })
          }
          // actions={[
          //   (rowData) => {
          //     if (rowData?.documentKey && type === "Export") {
          //       return {
          //         icon: () => <GetAppOutlinedIcon />,
          //         // tooltip: "Download",
          //         // disabled: rowData.status === "IN_PROGRESS",
          //         onClick: (event, rowData) => {
          //           dispatch(
          //             postGenerateUrl({
          //               dockey: rowData?.documentKey,
          //             },
          //               type
          //             )
          //           );
          //         },
          //       };
          //     }
          //   },

          //   (rowData) => {
          //     if (rowData?.logDocumentKey) {
          //       return {
          //         icon: () => <ArchiveOutlinedIcon />,
          //         // disabled: rowData.status === "IN_PROGRESS",
          //         tooltip: "Download",

          //       };
          //     }
          //   },
          // ]}
          options={{
            search: false,
            pageSize: rows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            toolbar: false,
            pageSizeOptions: tablePageRows,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer">
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              </div>
            ),
          }}
        />
        {/* {downloadSuccessMsg && <SuccessSnackbar successMsg={downloadSuccessMsg} />} */}
      </div>
      {/* {loading && <PageLoader />} */}
    </>
  );
};

export default DmExecutionTable;
